{
    "name": "backend",
    "version": "1.9.2",
    "scripts": {
        "ng": "ng",
        "start:prod": "ng serve  --configuration=production",
        "start": "ng serve",
        "local": "ng serve -c local",
        "build": "ng build",
        "build:local": "ng build local",
        "build:dev": "ng build --configuration=development",
        "lang": "ng extract-i18n --output-path src/locale --format=json",
        "watch": "ng build --watch --configuration development",
        "watch:local": "ng build --watch --configuration local",
        "test": "ng test",
        "lint:styles": "stylelint \"src/**/*.scss\"",
        "lint:styles:fix": "stylelint \"src/**/*.scss\" --fix",
        "prepare": "husky install"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.1.0",
        "@angular/cdk": "^19.1.2",
        "@angular/common": "^19.1.4",
        "@angular/compiler": "^19.1.0",
        "@angular/core": "^19.1.0",
        "@angular/forms": "^19.1.0",
        "@angular/material": "^19.1.2",
        "@angular/material-moment-adapter": "19.2.19",
        "@angular/platform-browser": "^19.1.0",
        "@angular/platform-browser-dynamic": "^19.1.0",
        "@angular/router": "^19.1.0",
        "@ngx-translate/core": "^16.0.4",
        "angularx-qrcode": "^19.0.0",
        "js-sha1": "^0.7.0",
        "moment": "2.30.1",
        "ngx-cookie-service": "^19.1.0",
        "ngx-image-cropper": "^9.1.2",
        "rxjs": "~7.8.0",
        "translate": "^3.0.1",
        "tslib": "^2.3.0",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.1.8",
        "@angular/cli": "^19.1.8",
        "@angular/compiler-cli": "^19.1.0",
        "@angular/localize": "^19.1.4",
        "@semantic-release/commit-analyzer": "^13.0.1",
        "@semantic-release/git": "^10.0.1",
        "@semantic-release/gitlab": "^13.3.3",
        "@semantic-release/npm": "^13.2.0",
        "@semantic-release/release-notes-generator": "^14.1.1",
        "@types/jasmine": "~5.1.0",
        "conventional-changelog-conventionalcommits": "^9.3.1",
        "husky": "^8.0.0",
        "jasmine-core": "~5.5.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "semantic-release": "^25.0.9",
        "stylelint": "17.0.0",
        "stylelint-config-standard-scss": "17.0.0",
        "typescript": "~5.7.2"
    }
}
